export const INITIAL_FORM = {
    name: "",
    details: "",
    date: -1,
    timeStart: -1,
    timeEnd: -1
};
export const INITIAL_ERRORS = {
    schedule: {
        value: false,
        text: ""
    }
};
export const ERROR_TEXTS = {
    START_DATE_IS_GREATER_THAN_END_DATE: "La hora de inicio es mayor o igual a la de fin.",
    PAST_SCHEDULE: "El rango de horas es pasado.",
    CROSS_SCHEDULES: "Existe un cruce de horarios con las horas seleccionadas."
};